<div
  class="app-header"
  [class.collapsed]="!isExpanded()"
>
  @if (isEnvironmentBannerEnabled()) {
    <procure-environment-banner [identifier]="environmentInfo.id">
      Environment: <b>{{ environmentInfo.title }}</b> – Build date:
      <b>{{ environmentInfo.buildInfo.timestamp | date }}</b>
    </procure-environment-banner>
  }
  <div class="container">
    <div class="brand">
      <a
        class="logo-container"
        routerLink="/"
      >
        <img
          class="logo-image large"
          alt="Procure App Logo"
          [src]="'./assets/images/logo-procure-brand.svg' | fileHash"
        />
        <img
          class="logo-image small"
          alt="Procure App Logo"
          [src]="'./assets/images/logo-procure-brand-small.svg' | fileHash"
        />
      </a>
      <button
        class="toggle"
        procure-button
        condensed
        variant="ghost"
        color="white"
        (click)="toggleMenu()"
      >
        <mat-icon>menu</mat-icon>
      </button>
    </div>
    <div class="search">
      <procure-search />
    </div>
    @if (menu().length || currentUser()) {
      <div class="buttons">
        @if (isSubstitute()) {
          <button
            class="button"
            procure-button
            variant="ghost"
            color="white"
            [matTooltip]="`Impersonating ${currentUser()?.name}`"
            (click)="logoutSubstituteUser()"
          >
            <mat-icon>admin_panel_settings</mat-icon>
          </button>
        }
        @if (tsp(); as tsp) {
          <button
            class="button"
            procure-button
            variant="ghost"
            color="white"
            [matTooltip]="tsp.description || ''"
            (click)="resourceClick(tsp)"
          >
            <mat-icon>{{ tsp.icon }}</mat-icon>
          </button>
        }
        <procure-inbox />
        @if (menu().length) {
          <button
            class="button"
            procure-button
            variant="ghost"
            color="white"
            matTooltip="Resources"
            [matMenuTriggerFor]="resourcesMenu"
          >
            <mat-icon>library_books</mat-icon>
          </button>
        }
        @if (currentUser(); as user) {
          @if (
            user.permissions.canViewOrganisation ||
            user.permissions.canManageOrganization ||
            user.permissions.canManageUsers ||
            user.permissions.canManageNotifications ||
            user.permissions.canManageResources ||
            user.permissions.canViewVendorView
          ) {
            <button
              class="button"
              procure-button
              variant="ghost"
              color="white"
              matTooltip="Settings"
              [matMenuTriggerFor]="settingsMenu"
            >
              <mat-icon>settings</mat-icon>
            </button>
          }
          <button
            class="button user"
            procure-button
            variant="ghost"
            [matTooltip]="user.name"
            [matMenuTriggerFor]="userMenu"
          >
            <procure-avatar
              class="avatar"
              [avatar]="user.avatarUrl"
              [name]="user.name"
            />
          </button>
        }
      </div>
    }
    <mat-menu #resourcesMenu="matMenu">
      @for (item of menu(); track item.id) {
        <a
          mat-menu-item
          [id]="`app-header-${item.id}`"
          [href]="!item.isDocument ? item.url : '#'"
          [attr.target]="!item.isDocument ? '_blank' : null"
          [attr.rel]="!item.isDocument ? 'noopener noreferrer' : null"
          [matTooltip]="item.description || ''"
          (click)="resourceClick(item)"
        >
          <mat-icon>{{ item.icon ? item.icon : "open_in_new" }}</mat-icon> {{ item.name }}
        </a>
      }
    </mat-menu>
    <mat-menu #userMenu="matMenu">
      <a
        mat-menu-item
        routerLink="/user/profile"
      >
        <mat-icon>person</mat-icon> Profile
      </a>
      <a
        mat-menu-item
        routerLink="/user/settings"
      >
        <mat-icon>settings</mat-icon> Settings
      </a>
      <a
        mat-menu-item
        routerLink="/user/notifications"
      >
        <mat-icon>notifications</mat-icon> Notifications
      </a>
      <button
        mat-menu-item
        (click)="logout()"
      >
        <mat-icon>logout</mat-icon> Logout
      </button>
    </mat-menu>
    <mat-menu #settingsMenu="matMenu">
      @if (currentUser()?.permissions?.canViewOrganisation) {
        <div
          mat-menu-item
          disabled
        >
          Organisation
        </div>
      }
      @if (currentUser()?.permissions?.canViewOrganisation) {
        <a
          mat-menu-item
          routerLink="/organisation"
        >
          <mat-icon>business</mat-icon>
          Organisation
        </a>
      }
      @if (currentUser()?.permissions?.canManageUsers) {
        <a
          mat-menu-item
          routerLink="/management/users"
        >
          <mat-icon>person</mat-icon> Users
        </a>
      }
      @if (currentUser()?.permissions?.canManageNotifications || currentUser()?.permissions?.canManageResources) {
        <div
          mat-menu-item
          disabled
        >
          Management
        </div>
      }
      @if (currentUser()?.permissions?.canManageNotifications) {
        <a
          mat-menu-item
          routerLink="/management/global-notification"
        >
          <mat-icon>announcement</mat-icon> Global Notification
        </a>
      }
      @if (currentUser()?.permissions?.canManageResources) {
        <a
          mat-menu-item
          routerLink="/management/resources"
        >
          <mat-icon>library_books</mat-icon> Resources
        </a>
      }
      @if (
        currentUser()?.permissions?.canManageAISettings ||
        currentUser()?.permissions?.canViewVendorView ||
        currentUser()?.permissions?.canViewMonitoring
      ) {
        <div
          mat-menu-item
          disabled
        >
          Vendor
        </div>
      }
      @if (currentUser()?.permissions?.canManageAISettings) {
        <a
          href="/ai"
          mat-menu-item
        >
          <mat-icon>psychology</mat-icon> AI
        </a>
      }
      @if (currentUser()?.permissions?.canViewVendorView) {
        <a
          mat-menu-item
          routerLink="/vendor"
        >
          <mat-icon>admin_panel_settings</mat-icon> Vendor
        </a>
      }
      @if (currentUser()?.permissions?.canViewMonitoring) {
        <a
          mat-menu-item
          routerLink="/monitoring"
        >
          <mat-icon>troubleshoot</mat-icon> Monitoring
        </a>
      }
    </mat-menu>
  </div>
</div>
